/** Full search results, grouped by record type. */
import { Link, useSearchParams } from 'react-router'
import { Cover } from '../components/Cover'
import { Empty, Loading } from '../components/Bits'
import { qs } from '../lib/api'
import { categoryLabel, recordHref, TYPE_LABELS } from '../lib/format'
import { useQuery } from '../lib/query'
import { useTitle } from '../lib/useTitle'
import type { ExplicitCount, SearchHit } from '../lib/types'
import { ExplicitNotice } from '../components/ExplicitNotice'
import { Mature } from '../components/Cards'
import { ENTITY_TYPES } from '../../shared/model'

export function SearchPage() {
  const [params] = useSearchParams()
  const q = params.get('q')?.trim() ?? ''
  useTitle(q ? `“${q}”` : 'Search')
  const { data } = useQuery<{ items: SearchHit[]; explicit?: ExplicitCount }>(
    q ? `/api/v1/search${qs({ q, limit: 50, explicit: params.get('explicit') })}` : null,
  )
  return (
    <div className="page">
      <h1 className="page-title">{q ? <>Results for “{q}”</> : 'Search'}</h1>
      {q && <ExplicitNotice explicit={data?.explicit} noun="record" />}
      {!q ? (
        <p className="lede">Type in the search box above. Press / from anywhere to jump to it.</p>
      ) : !data ? (
        <Loading label="Searching" />
      ) : data.items.length === 0 ? (
        <Empty title="Nothing found">
          <p>Check the spelling, or try a shorter name. If it really is missing, you can add it.</p>
          <p>
            <Link to="/new">Add a record</Link>
          </p>
        </Empty>
      ) : (
        ENTITY_TYPES.map((type) => {
          const hits = data.items.filter((h) => h.type === type)
          if (!hits.length) return null
          return (
            <section key={type} className="section">
              <h2 className="section-title">{TYPE_LABELS[type].many}</h2>
              <ul className="result-list">
                {hits.map((h) => (
                  <li key={h.id}>
                    <Link to={recordHref(h.type, h.id)} className="result">
                      {type !== 'publisher' && type !== 'creator' && <Cover cover={h.cover} title={h.name} size="sm" />}
                      <span className="result-name">{h.name}</span>
                      {(h.detail || h.is_explicit) && (
                        <span className="result-detail">
                          {type === 'book' && h.detail
                            ? categoryLabel(h.detail.split(' · ')[0]!) +
                              (h.detail.includes(' · ') ? ` · ${h.detail.split(' · ')[1]}` : '')
                            : h.detail}
                          {h.is_explicit && <Mature labelled />}
                        </span>
                      )}
                    </Link>
                  </li>
                ))}
              </ul>
            </section>
          )
        })
      )}
    </div>
  )
}
